import React from "react";

import * as Icons from "/component/base/Icon";
import Text from "/component/base/Text";
import useSystemMessage from "/hook/useSystemMessage";

import { Banner, CloseButton, Container, Content, StyledLink } from "./SystemMessage.styles";

const SystemMessage: React.FC = () => {
  const { message, isOpen, close, link, linkText, dismissable } = useSystemMessage();

  if (!isOpen || !message) {
    return null;
  }

  return (
    <Container>
      <Banner>
        <Icons.TriangleExclamation size={24} />
        <Content>
          <Text variant="body2">{message}</Text>
          {link && (
            <StyledLink target="_blank" href={link}>
              {linkText || "Learn more"}
            </StyledLink>
          )}
        </Content>
        {dismissable && (
          <CloseButton onClick={close} aria-label="Dismiss message">
            <Icons.Close size={16} color="textPrimary" />
          </CloseButton>
        )}
      </Banner>
    </Container>
  );
};

export default SystemMessage;
